import { Dialog } from "primereact/dialog";
import { ILead } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";

const schema = yup.object({
    status_ID: yup.number().required("Status is required").min(1, "Status is required"),
});

interface Iprops {
    singleData: ILead,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    hasPermission: (pageName: string, featureName?: string) => boolean,
    reloadData: () => void,
    reload: boolean,

}
interface IAccessoryGroup {
    accessoriesID: number;
    accessoriesName: string;
    quantity: number;
    rate: number;
    totalAmount: number;
}
interface ISubscriptionGroup {
    device_ID: number;
    plan_ID: number;
    base_Price: number;
    deal_Price: number;
    plan_Name: string;
}

export const AccessoriesDetails = (props: Iprops) => {
    const [accessoryGroups, setAccessoryGroups] = useState<IAccessoryGroup[]>([]);
    const [subscriptionGroups, setSubscriptionGroups] = useState<ISubscriptionGroup[]>([]);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<ILead>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        loadAccessoryGroups();
        loadAttachDeviceGroups();
    }, [props.open]);

    useEffect(() => {
        const updatedData = {
            ...props.singleData,
        };
        reset(updatedData);
    }, [props.singleData]);

    const loadAccessoryGroups = async () => {
        const res = await Fetch(`Leads/getAttachAccessorGroupwise/${props.singleData.id}`, "GET", null, null, null);
        if (res) {
            const json = await res.json();
            setAccessoryGroups(json.data);
        }
    }

    const loadAttachDeviceGroups = async () => {
        const res = await Fetch(`Leads/getAttachDeviceById/${props.singleData.id}`, "GET", null, null, null);
        if (res) {
            const json = await res.json();
            setSubscriptionGroups(json.data);
        }
    }

    const onHide = () => {
        props.hideDialog();
    }


    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '600px' }} header={`Invoice`} modal className="p-fluid" onHide={onHide}>
            {props.singleData.status_ID === 4 && <div className="col-12">
                <h5>Subscription Details</h5>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Plan Name</th>
                            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Base Price($)</th>
                            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Deal Price($)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {subscriptionGroups.map(item => (
                            <tr key={item.device_ID}>
                                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.plan_Name}</td>
                                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.base_Price}</td>
                                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.deal_Price}</td>
                            </tr>
                        ))}
                        <tr>
                            <td colSpan={2} style={{ border: '1px solid #ccc', padding: '8px', fontWeight: 'bold' }}>Grand Total $</td>
                            <td style={{ border: '1px solid #ccc', padding: '8px', fontWeight: 'bold' }}>
                                {subscriptionGroups.reduce((sum, item) => sum + (item.deal_Price || 0), 0)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>}

            <div className="col-12">
                <h5>Accessories Details</h5>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Accessories</th>
                            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Qty</th>
                            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Rate($)</th>
                            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Total($)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {accessoryGroups.map(item => (
                            <tr key={item.accessoriesID}>
                                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.accessoriesName}</td>
                                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.quantity}</td>
                                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.rate}</td>
                                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.totalAmount}</td>
                            </tr>
                        ))}
                        <tr>
                            <td colSpan={3} style={{ border: '1px solid #ccc', padding: '8px', fontWeight: 'bold' }}>Grand Total $</td>
                            <td style={{ border: '1px solid #ccc', padding: '8px', fontWeight: 'bold' }}>
                                {accessoryGroups.reduce((sum, item) => sum + (item.totalAmount || 0), 0)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
            </div>
        </Dialog>
    );
}